import {post} from 'api';
import config from 'config';

const invetoryByParts = config.get('api.invetoryByParts');

export const GetInvetoryByParts = async (request :any): Promise<any> => {  
    let url = `${invetoryByParts}/api/Query`; 
    const { data } = await post(url, request);
    return data;
};